export const TABLE_ITEMS_CLASSNAMES = {
	avatar: 'avatar',
	fullName: 'fullName',
	age: 'age',
	email: 'email',
	phone: 'phone',
	gender: 'gender',
	location: 'location',
	forms: 'forms',
	totalTimeSpent: 'totalTimeSpent',
	date: 'date',
	time: 'time',
	duration: 'duration',
	options: 'options',
	userOptions: 'userOptions',
	chesedName: 'chesedName',
	coordinator: 'coordinator',
	challenge: 'challenge',
	volunteers: 'volunteers',
	volunteers_actions: 'volunteers_actions',
	checkbox: 'checkbox',
	listOrganizations: 'listOrganizations',
	logo: 'avatar',
	type: 'type',
	contacts: 'contacts',
	owner: 'owner',
	totalVolunteers: 'total_volunteers',
	totalUsers: 'total_users',
	totalOppos: 'total_oppotunities',
	totalOppoHours: 'total_oppotunity_hours',
	position: 'position',
	organizations: 'organizations',
	organization: 'organization',
	coins: 'coins',
	role: 'role',
	grade: 'grade',
	spendTime: 'spend_time',
	// suspend: 'suspend',
};
